import * as React from 'react';
import { Route, Switch } from 'react-router';
import { useLocation } from 'react-router-dom';

import { MainPage } from '../../../MainPage';
import { PageReload } from '../../../../components/PageReload';

export const Routes = () => {
  const { search } = useLocation();
  const qs = new URLSearchParams(search);

  return (
    <Switch>
      <Route path={`/magazine/`} component={MainPage}>
        {(qs.get('tag') || qs.get('search')) && (
          <>
            <PageReload />
            <MainPage />
          </>
        )}
      </Route>
      <Route>
        <PageReload />
        <MainPage />
      </Route>
    </Switch>
  );
};
